import { Badge } from "@/components/ui/badge";
import { ROLE_LABELS } from "./role-options";
import type { UserRole } from "@/types/api";

const ROLE_VARIANT: Record<UserRole, "purple" | "blue" | "gray"> = {
  SuperAdmin: "purple",
  OrgAdmin: "blue",
  Viewer: "gray",
};

export function RoleBadge({ role }: { role: UserRole }) {
  return <Badge variant={ROLE_VARIANT[role]}>{ROLE_LABELS[role]}</Badge>;
}
